import _                                 from 'underscore';
import { useOffScreenNodeElementToggle } from './useOffScreenNodeElementToggle';
import { PopupProps }                    from 'semantic-ui-react';
import { useEffect }                     from 'react';

type UsePopupWithOffScreenNodeToggleSupportHookMethod = () => UsePopupWithOffScreenNodeToggleSupportHook;

export type UsePopupWithOffScreenNodeToggleSupportHook = {
	offScreenSupportProps: Pick<PopupProps, 'open' | 'onOpen' | 'onClose'>
};

export const usePopupWithOffScreenNodeToggleSupport: UsePopupWithOffScreenNodeToggleSupportHookMethod = () => {
	
	const offScreenToggler = useOffScreenNodeElementToggle();
	
	useEffect( () => {
		
		return () => {
			
			// Clean up the event listener
			offScreenToggler.removeOffScreenToggleClickHandler();
		}
	} )
	
	function documentClickHandler( e ){
		
		// Are we inside the popup?
		if( _.isNull( e.target.closest( '.popup' ) ) ){
			
			// Close the popup
			offScreenToggler.setToggleState( false );
			
		} else {
			
			// Listen for a new one-time click on document
			document.addEventListener( 'click', documentClickHandler, { once: true } );
		}
	}
	
	return {
		
		offScreenSupportProps: {
			
			// Manually control the state due to the data picker
			// being a child of the toolbar within the popup container
			open: offScreenToggler.toggleState,
			
			onOpen: ( e, data ) => {
				
				// Setup state and toggle events
				offScreenToggler.setToggleFunction( () => offScreenToggler.setToggleState( false ) )
				offScreenToggler.attachOffScreenToggleClickHandler();
				offScreenToggler.setToggleState( true );
				
				document.addEventListener( 'click', documentClickHandler, { once: true } );
			},
			
			onClose: ( e, data ) => {
				
				// Clean up the event listener
				offScreenToggler.removeOffScreenToggleClickHandler();
			}
		}
	}
};
